import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { message } from "antd";

import sdk, { GraphQLError } from "@/sdk";

export const useBonds = ({ limit = 20 }: { limit?: number } = {}) => {
  const [page, setPage] = useState(0);

  const {
    data,
    isLoading: isLoadingBonds,
    refetch,
  } = useQuery(["bonds", page, limit], () => sdk.getBonds({ page, limit }), {
    select: (data) => data.getBonds,
  });

  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation({
    mutationFn: (id: string) => sdk.deleteBond({ _id: id }),
    onSuccess: () => {
      message.success("Амжилттай устгагдлаа");
      queryClient.invalidateQueries(["bonds"]);
    },
    onError: (err) => {
      message.warn((err as GraphQLError).response?.errors[0]?.message, 2);
    },
  });

  const { mutate: mutatePayout, isLoading: isPayoutLoading } = useMutation({
    mutationFn: (params: { batchId: string; bondId: string }) =>
      sdk.payoutPathInterest(params),
    onSuccess: () => {
      message.success(
        "Таны хүсэлтийг хүлээж авлаа. Та хүү олголт дуустал дахиж хүсэлт илгээх шаардлагагүй.",
      );
    },
    onError: (err) => {
      message.warn((err as GraphQLError).response?.errors[0]?.message, 2);
    },
  });

  return {
    data,
    loading: isLoadingBonds || isLoading,
    getBonds: refetch,
    deleteBond: mutate,
    setPage,
    payout: mutatePayout,
    isPayoutLoading,
  };
};
